import { format, startOfMonth, endOfMonth, addDays, parseISO } from 'date-fns'

interface CalendarEventRequest {
  startdate: string
  enddate: string
  calendarData: string[]
}

interface CalendarEvent {
  id: number
  availability: boolean
  allDay?: boolean
  start?: string
  end?: string
  date: string
  displayDate: string
}

export function getDateFormatsForUser({ date }) {
  const startDate = addDays(startOfMonth(new Date(date)), -7)
  const endDate = addDays(endOfMonth(new Date(date)), 7)
  const fullDays = addDays(endOfMonth(new Date()), 300)

  return {
    formattedtMonth: format(new Date(date), 'yyyy-MMM'),
    formattedStartDate: format(startDate, 'yyyy-MM-dd'),
    formattedEndDate: format(endDate, 'yyyy-MM-dd'),
    formattedFullDate: format(fullDays, 'yyyy-MM-dd'),
  }
}

export function getStartAndEndDatesForCalendarUpdate({ date }) {
  return {
    calendarStartDate: addDays(startOfMonth(new Date(date)), -7),
    calendarEndDate: addDays(endOfMonth(new Date(date)), 7),
  }
}

export function generateCalendarEvents({
  startdate,
  enddate,
  calendarData = [],
}: // }: CalendarEventRequest): CalendarEvent[] {
CalendarEventRequest): any {
  let startDate = parseISO(startdate)
  const endDate = parseISO(enddate)

  // let startDate = parseISO(startdate).addDays(-7)
  // const endDate = parseISO(enddate).addDays(7)
  const availabilityDates: CalendarEvent[] = []
  let index = 1

  while (startDate <= endDate) {
    const formattedDate = format(startDate, 'yyyy-MM-dd HH:mm:ss')
    const displayDate = format(startDate, 'yyyy-MM-dd')

    availabilityDates.push({
      id: index,
      availability: !calendarData.includes(displayDate),
      allDay: true,
      start: formattedDate,
      end: formattedDate,
      date: formattedDate,
      displayDate,
    })
    startDate = addDays(startDate, 1)
    index++
  }

  return availabilityDates
}
